import type { DashboardKpis } from "../../../api/dashboard";

/** True when the org has no posted activity in the selected dashboard period. */
export function isEmptyOrgKpis(kpis: DashboardKpis): boolean {
  return (
    kpis.totalSalesMinor === 0 &&
    kpis.totalExpensesMinor === 0 &&
    kpis.cashBalanceMinor === 0 &&
    kpis.bankBalanceMinor === 0 &&
    kpis.receivablesMinor === 0 &&
    kpis.payablesMinor === 0 &&
    kpis.pendingWorkOrdersCount === 0 &&
    kpis.activeEmployeesCount === 0
  );
}
